/**
 * Merged Foto + KTP: two columns on large screens (foto kiri, KTP kanan).
 */

import * as React from "react";
import type { User } from "@/services/authService";
import { PhotoTab } from "./PhotoTab";
import { KTPTab } from "./KTPTab";

interface PhotoKtpTabProps {
  user: User;
  /** Foto profil hanya dapat diubah pemilik akun; admin melihat kolom KTP saja. */
  isOwnProfile: boolean;
}

export function PhotoKtpTab({ user, isOwnProfile }: PhotoKtpTabProps) {
  return (
    <div
      className={
        isOwnProfile
          ? "grid gap-6 lg:grid-cols-2 lg:items-start"
          : "grid gap-6"
      }
    >
      {isOwnProfile ? (
        <div className="min-w-0">
          <PhotoTab user={user} />
        </div>
      ) : null}
      <div className={isOwnProfile ? "min-w-0" : "min-w-0 lg:max-w-3xl"}>
        <KTPTab user={user} allowEdit={isOwnProfile} />
      </div>
    </div>
  );
}
